import { render, staticRenderFns } from "./budgetModal.vue?vue&type=template&id=004e6f04&scoped=true&"
import script from "./budgetModal.vue?vue&type=script&lang=js&"
export * from "./budgetModal.vue?vue&type=script&lang=js&"
import style0 from "./budgetModal.vue?vue&type=style&index=0&id=004e6f04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004e6f04",
  null
  
)

export default component.exports